<template>
  <v-app>
    <v-main class="mx-lg-auto">
      <router-link to="/home"></router-link>
      <router-view v-if="isRouterShow"></router-view>
    </v-main>
  </v-app>
</template>

<script>

export default {
  name: 'App',
  provide () {
    return {
      reload: this.reload
    }
  },
  data () {
    return {
      isRouterShow: true
    }
  },
  methods: {
    async reload () {
      this.isRouterShow = false
      await this.$nextTick()
      this.isRouterShow = true
    }
  }
}
</script>
